import { render, staticRenderFns } from "./Sedi.vue?vue&type=template&id=47c65f23&scoped=true&"
import script from "./Sedi.vue?vue&type=script&lang=js&"
export * from "./Sedi.vue?vue&type=script&lang=js&"
import style0 from "./Sedi.vue?vue&type=style&index=0&id=47c65f23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c65f23",
  null
  
)

export default component.exports